import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { motion } from 'framer-motion';
import { TYPEFORM_URL, CALENDLY_URL } from '@/data/mock';
import { CTAButton } from '@/components/shared/SharedComponents';
import { Calendar } from 'lucide-react';

export default function ContactoPage() {
  const { currentTheme: t } = useTheme();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      <section className="pt-28 lg:pt-36 pb-16 lg:pb-24" style={{ background: t.heroBg }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>
            Completa tus datos y te contactaremos
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg mb-8" style={{ color: t.textSecondary }}>
            Agenda una reunión con nuestro equipo
          </motion.p>
        </div>
      </section>

      <section className="py-16" style={{ background: t.bg }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-xl border overflow-hidden" style={{ borderColor: t.borderColor }}>
            <iframe
              src={TYPEFORM_URL}
              title="Formulario de contacto"
              className="w-full"
              style={{ height: '600px', border: 0 }}
            />
          </div>
          <div className="text-center mt-10">
            <p className="text-sm mb-4" style={{ color: t.textMuted }}>O agenda directamente una reunión:</p>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold border transition-colors duration-200"
              style={{ color: t.text, borderColor: t.borderColor }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = t.accent}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = t.borderColor}
            >
              <Calendar size={16} />
              Agendar reunión
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
